export const BUILDING_UUID_PARAM_KEY = 'building_uuid'